import { Injectable } from '@angular/core'

@Injectable({
	providedIn: 'root',
})
export class BrowserNotificationService {
	/**
	 * Requests permission from the user to show desktop notifications.
	 */
	public requestPermission(): void {
		if (!('Notification' in window)) {
			console.error()
			return
		}

		// Let's check whether notification permissions have already been granted
		if (Notification.permission === 'granted') {
			console.log('Notification permission has already been granted.')
			return
		}

		// Otherwise, we need to ask the user for permission
		Notification.requestPermission().then(permission => {
			if (permission === 'granted') {
				console.log('Notification permission granted.')
			} else {
				console.warn('Notification permission was denied.')
			}
		})
	}

	/**
	 * Shows a notification to the user.
	 * @param title The title of the notification.
	 * @param body The body text of the notification.
	 */
	public showNotification(title: string, body: string): void {
		if (Notification.permission === 'granted') {
			// If permission is granted, create the notification
			new Notification(title, {
				body: body,
				icon: '/assets/images/Tada.svg', // Optional: Use an icon from your assets
			})
		}
	}
}
